import { Box, FormControl, FormControlLabel, FormGroup, Checkbox as MuiCheckbox } from '@mui/material';
import type { WidgetProps } from 'app/schema-form/types';
import type { ChangeEvent } from 'react';
import { useWidgetTitle } from '../../../../schema-form/util/widget.js';
import FieldInfo from '../../field-info/index.js';
import InfoTooltip from '../../info-tooltip/index.js';

export type CheckboxOwnProps = WidgetProps;

export type CheckboxContainerProps = {
  readonly handleChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export type CheckboxProps = CheckboxOwnProps & CheckboxContainerProps;

export function Checkbox(props: CheckboxProps) {
  const { value, schema, config, disabled, readOnly, formName, path, handleChange } = props;
  const enabled = typeof value === 'boolean' ? value : schema.get('default', false);
  const description = schema.get('description');
  const instructions = config?.get('instructions');
  const title = useWidgetTitle(props);

  const inlineDescription =
    description && !instructions ? (
      <Box component="span" ml={0.5} sx={{ svg: { marginTop: '-2px' } }}>
        <InfoTooltip text={description} />
      </Box>
    ) : undefined;

  return (
    <FormControl fullWidth>
      <FormGroup>
        <FormControlLabel
          control={
            <MuiCheckbox
              checked={enabled}
              onChange={handleChange}
              disabled={Boolean(disabled) || Boolean(readOnly)}
              data-testid={`${formName}-${path}`}
            />
          }
          label={
            <>
              {title} {inlineDescription}
            </>
          }
        />
        {!inlineDescription && <FieldInfo description={description} instructions={instructions} />}
      </FormGroup>
    </FormControl>
  );
}
